/**
 * Deep link the user tried to open while unauthenticated. The app initializer stores it
 * before redirecting to `/login`; the login effect consumes it after a successful login.
 */
const POST_LOGIN_REDIRECT_STORAGE_KEY = 'postLoginRedirectUrl';

/** Only same-origin absolute paths are allowed, so a stored value can't turn into an open redirect. */
const isSafeRedirectUrl = (url: string): boolean =>
    url.startsWith('/') && !url.startsWith('//') && !url.startsWith('/login');

export function persistPostLoginRedirectUrl(): void {
    const currentUrl = `${ window.location.pathname }${ window.location.search }${ window.location.hash }`;

    if (currentUrl !== '/' && isSafeRedirectUrl(currentUrl)) {
        localStorage.setItem(POST_LOGIN_REDIRECT_STORAGE_KEY, currentUrl);
    }
}

export function takePostLoginRedirectUrl(): string | null {
    const redirectUrl = localStorage.getItem(POST_LOGIN_REDIRECT_STORAGE_KEY);
    localStorage.removeItem(POST_LOGIN_REDIRECT_STORAGE_KEY);

    return redirectUrl && isSafeRedirectUrl(redirectUrl) ? redirectUrl : null;
}
